import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { OpenSpace } from 'src/app/entities/openSpace';
import { OpenSpaceService } from 'src/app/services/open-space.service';
import { NgForm, FormGroupDirective, FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { TemplateService } from 'src/app/services/template.service';
import { CategoryTemplate } from 'src/app/entities/template';
import { Category } from 'src/app/entities/category';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css']
})
export class AddComponent implements OnInit {

  constructor(private templateService: TemplateService, private openService: OpenSpaceService,
              private  dialogRef: MatDialogRef<AddComponent>,
              @Inject(MAT_DIALOG_DATA) public data: AddComponent, public confirmationDialog: MatDialog) { }

  editMode = this.data.editMode;
  viewMode = this.data.viewMode;
  templates: CategoryTemplate[];
  categories: Category[];
  matcher = new MyErrorStateMatcher();
  name = new FormControl('', [Validators.required, ]);
  description = new FormControl('');
  allowProposalsFromDate = new FormControl('', [Validators.required, ]);
  allowProposalsUntilDate = new FormControl('', [Validators.required, ]);
  allowVotingFromDate = new FormControl('', [Validators.required, ]);
  allowVotingUntilDate = new FormControl('', [Validators.required, ]);
  eventDate = new FormControl('', [Validators.required, ]);
  maxVotes = new FormControl('', [Validators.required, ]);
  template = new FormControl('', Validators.required);
  showVotes = new FormControl(true);
  showProposer = new FormControl(true);
  openSpace: OpenSpace = this.data?.openSpace;
  openSpaceId = this.data?.openSpace?.id;
  formGroup = new FormGroup({ name: this.name, description: this.description,
  allowProposalsFromDate: this.allowProposalsFromDate, allowProposalsUntilDate: this.allowProposalsUntilDate,
  allowVotingFromDate: this.allowVotingFromDate, allowVotingUntilDate: this.allowVotingUntilDate,
  eventDate: this.eventDate, maxVotes: this.maxVotes, showVotes: this.showVotes, showProposer: this.showProposer, template: this.template
  });
  disable: boolean;


  ngOnInit(): void {
    if (this.editMode)
    {
      this.openToForm();
    }
    if (this.viewMode)
    {
      this.openToForm();
      this.formGroup.disable();
    }
    this.getCategoryTemplates();
  }

  getCategoryTemplates() {
    this.templateService.getCategoryTemplates()
      .subscribe(
        (data) => {
          this.templates = data.categoryTemplates;
        },
        (error) => {
          console.error(error);
        }
      );
  }

  changeTemplate(template) {
    const selectedTemplate = this.templates.find((data: any) => data.id === template.value);
    if (selectedTemplate)
    {
      this.categories = selectedTemplate.categories;
    }
  }

  onSubmit(){
    this.matcher.submited = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.disable = true;
    this.transformToOpen();

    if (this.editMode) {
      this.openService.updateOpen(this.openSpace, this.openSpaceId)
      .subscribe(
        (_) => {
          this.onClose();
        },
        (error) => {
          console.error(error);
          this.disable = false;
        });
    }
    else {
      this.openService.addOpen(this.openSpace)
      .subscribe(
        (_) => {
          this.onClose();
          this.disable = false;
        },
        (error) => {
          console.error(error);
          this.disable = false;
        });
    }
  }

  public onClose() {
    this.dialogRef.close();
  }

  transformToOpen(){
    this.openSpace = new OpenSpace();
    this.openSpace.name = this.formGroup.get('name').value;
    this.openSpace.description = this.formGroup.get('description').value;
    this.openSpace.allowProposalsFromDate = this.formGroup.get('allowProposalsFromDate').value;
    this.openSpace.allowProposalsUntilDate = this.formGroup.get('allowProposalsUntilDate').value;
    this.openSpace.allowVotingFromDate = this.formGroup.get('allowVotingFromDate').value;
    this.openSpace.allowVotingUntilDate = this.formGroup.get('allowVotingUntilDate').value;
    this.openSpace.eventDate = this.formGroup.get('eventDate').value;
    this.openSpace.maxVotes = this.formGroup.get('maxVotes').value;
    this.openSpace.showVotes = this.formGroup.get('showVotes').value;
    this.openSpace.showProposer = this.formGroup.get('showProposer').value;
    this.openSpace.categoryTemplateId = this.formGroup.get('template').value;
  }

  openToForm(){
    if (this.openSpace !== undefined) {
      this.name.setValue(this.openSpace.name);
      this.description.setValue(this.openSpace.description);
      this.allowProposalsFromDate.setValue(this.openSpace.allowProposalsFromDate);
      this.allowProposalsUntilDate.setValue(this.openSpace.allowProposalsUntilDate);
      this.allowVotingFromDate.setValue(this.openSpace.allowVotingFromDate);
      this.allowVotingUntilDate.setValue(this.openSpace.allowVotingUntilDate);
      this.eventDate.setValue(this.openSpace.eventDate);
      this.maxVotes.setValue(this.openSpace.maxVotes);
      this.showVotes.setValue(this.openSpace.showVotes);
      this.showProposer.setValue(this.openSpace.showProposer);
      this.template.setValue(this.openSpace.categoryTemplateId);
    }
  }

  openConfirmationDialog() {
    if (this.editMode){
      this.confirmationDialog
        .open(ConfirmationDialogComponent, {
          data: '¿Desea modificar el Open Space?'
        })
        .afterClosed()
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.onSubmit();
          }
        });
    }
    else{
      this.onSubmit();
    }
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  submited = false;
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = this.submited;
    return !!(control && control.invalid && (isSubmitted));
  }
}
